export const arrowChevronUpIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
  <path d="M0.0195312 8.24436L1.96721 10.1538L8.00198 4.23742L14.0342 10.1513L15.9818 8.24181L8.00247 0.417969L0.0195312 8.24436Z" fill="var(--zbp-svg-primary-color, black)"/>
</svg>
`;
